import React from 'react';
import FormHistory from 'modules/FormHistory';

const Aftersale = ({ contact, portfolioUuid, profileUuid }) => {
  const isCompany = contact.type === 'COMPANY';
  const key = isCompany
    ? 'c_aftersale'
    : 'p_aftersale';

  return <FormHistory
    formKey={key}
    contactName={contact.name}
    portfolioUuid={portfolioUuid}
    profileUuid={profileUuid}
  />;
};

export default Aftersale;
